(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-variant-pills"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const formatMoney = (cents) => {
      return `${(cents / 100).toFixed(2)}`;
    };

    const setMainImageInWrap = (wrap, url, altText) => {
      if (!wrap || !url) return;
      wrap.replaceChildren();
      const img = document.createElement('img');
      img.className = 'variant-pills__main-image';
      img.src = url;
      if (altText) img.alt = altText;
      img.setAttribute('loading', 'lazy');
      img.setAttribute('decoding', 'async');
      wrap.appendChild(img);
    };

    document.addEventListener('click', (event) => {
      const thumb = event.target.closest('.variant-pills__thumb');
      if (!thumb || thumb.tagName !== 'BUTTON') return;
      const sectionNode = thumb.closest('.variant-pills');
      if (!sectionNode) return;
      const wrap = sectionNode.querySelector('.variant-pills__main-image-wrap');
      const imageUrl = thumb.getAttribute('data-image-url');
      if (!wrap || !imageUrl) return;
      sectionNode.querySelectorAll('.variant-pills__thumb').forEach((node) => node.classList.remove('is-active'));
      thumb.classList.add('is-active');
      const alt = thumb.getAttribute('aria-label') || '';
      setMainImageInWrap(wrap, imageUrl, alt);
    });

    document.querySelectorAll('.variant-pills').forEach((sectionNode) => {
      const optionButtons = sectionNode.querySelectorAll('[data-option-value]');
      const bundleButtons = sectionNode.querySelectorAll('[data-bundle-option]');
      const variantInput = sectionNode.querySelector('[data-product-id-input]');
      const quantityInput = sectionNode.querySelector('[data-quantity-input]');
      const finalPriceEl = sectionNode.querySelector('[data-final-price]');
      const oldPriceEl = sectionNode.querySelector('[data-old-price]');
      const ctaButton = sectionNode.querySelector('[data-submit-cta]');
      const mainImageWrap = sectionNode.querySelector('.variant-pills__main-image-wrap');
      const variantsJsonNode = sectionNode.querySelector('[data-variants-json]');
      const ctaDefault = sectionNode.dataset.ctaDefault || 'Add to cart';
      const ctaSoldOut = sectionNode.dataset.ctaSoldOut || 'Sold out';
      const moneyFormat = sectionNode.dataset.moneyFormat || window?.Shopify?.money_with_currency_format || window?.Shopify?.money_format || '${amount}';
      const currencyCode = sectionNode.dataset.currencyCode || '';

      const formatPrice = (cents) => {
        if (window.Shopify && window.Shopify.formatMoney) {
          return window.Shopify.formatMoney(cents, moneyFormat);
        }
        const numeric = formatMoney(cents);
        if (currencyCode) return `${numeric} ${currencyCode}`;
        return numeric;
      };

      const variantsData = variantsJsonNode ? JSON.parse(variantsJsonNode.textContent) : [];
      const selectedOptions = {};
      let selectedBundle = sectionNode.querySelector('[data-bundle-option].is-active') || bundleButtons[0];

      const setActive = (nodes, activeNode) => {
        nodes.forEach((node) => {
          const isActive = node === activeNode;
          node.classList.toggle('is-active', isActive);
          node.setAttribute('aria-checked', isActive ? 'true' : 'false');
        });
      };

      optionButtons.forEach((button) => {
        const optionIndex = Number(button.dataset.optionIndex || 1);
        if (button.classList.contains('is-active')) {
          selectedOptions[optionIndex] = button.dataset.optionValueText;
        }
      });

      const getSelectedVariant = () => {
        const matchedVariants = variantsData.filter((variant) => {
          let isMatch = true;

          Object.keys(selectedOptions).forEach((indexKey) => {
            const optionIndex = Number(indexKey) - 1;
            if (variant.options[optionIndex] !== selectedOptions[indexKey]) {
              isMatch = false;
            }
          });

          return isMatch;
        });

        if (matchedVariants.length === 0) return variantsData[0];

        const firstAvailableMatch = matchedVariants.find((variant) => variant.available);
        if (firstAvailableMatch) return firstAvailableMatch;

        return matchedVariants[0];
      };

      const refreshPrice = () => {
        if (!variantInput || !quantityInput || !finalPriceEl || !oldPriceEl || variantsData.length === 0) return;

        const selectedVariant = getSelectedVariant();
        const variantPrice = Number(selectedVariant.price || 0);
        const quantity = Number(selectedBundle?.dataset.bundleQuantity || 1);
        const discount = Number(selectedBundle?.dataset.bundleDiscount || 0);
        const isAvailable = selectedVariant.available === true;

        const baseTotal = variantPrice * quantity;
        const discountedTotal = Math.round(baseTotal * (100 - discount) / 100);
        const showDiscount = discount > 0 && discountedTotal < baseTotal;

        finalPriceEl.textContent = formatPrice(discountedTotal);
        oldPriceEl.textContent = showDiscount ? formatPrice(baseTotal) : '';
        oldPriceEl.classList.toggle('is-hidden', !showDiscount);

        variantInput.value = selectedVariant.id;
        quantityInput.value = quantity;

        if (ctaButton) {
          ctaButton.disabled = !isAvailable;
          ctaButton.textContent = isAvailable ? ctaDefault : ctaSoldOut;
        }

        const variantImageUrl = selectedVariant.featured_image;
        if (variantImageUrl && mainImageWrap) {
          const matchedThumb = Array.from(sectionNode.querySelectorAll('.variant-pills__thumb')).find(
            (node) => node.getAttribute('data-image-url') === variantImageUrl
          );
          const alt = matchedThumb ? matchedThumb.getAttribute('aria-label') || '' : '';
          setMainImageInWrap(mainImageWrap, variantImageUrl, alt);
          sectionNode.querySelectorAll('.variant-pills__thumb').forEach((node) => {
            node.classList.toggle('is-active', node.getAttribute('data-image-url') === variantImageUrl);
          });
        }
      };

      optionButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const optionIndex = button.dataset.optionIndex;
          const groupButtons = sectionNode.querySelectorAll(`[data-option-value][data-option-index="${optionIndex}"]`);
          selectedOptions[optionIndex] = button.dataset.optionValueText;
          setActive(groupButtons, button);
          refreshPrice();
        });
      });

      bundleButtons.forEach((button) => {
        button.addEventListener('click', () => {
          selectedBundle = button;
          setActive(bundleButtons, button);
          refreshPrice();
        });
      });

      refreshPrice();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["protein-bundle-builder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-bundle-root]');

    // [NEW] Український формат: знак ₴ ПІСЛЯ числа з нерозривним пробілом, без копійок,
    // тисячі розділяються пробілом (999 ₴, 1 324 ₴). 2-й аргумент (format) ігнорується.
    const formatMoney = (cents) => {
      const n = Math.round(Number(cents || 0) / 100);
      return n.toLocaleString('uk-UA') + ' ₴';
    };

    roots.forEach((root) => {
      const parseMoneyToCents = (value) => {
        const raw = String(value ?? '').trim();
        if (!raw) return 0;
        const normalized = raw
          .replace(/\s/g, '')
          .replace(',', '.')
          .replace(/[^\d.]/g, '');
        if (!normalized) return 0;
        const amount = Number.parseFloat(normalized);
        if (!Number.isFinite(amount)) return 0;
        return Math.round(amount * 100);
      };
      const parsePercent = (value) => {
        const numeric = Number.parseFloat(String(value ?? '').replace(',', '.'));
        if (!Number.isFinite(numeric)) return 0;
        return Math.max(0, Math.min(100, numeric));
      };

      const tierButtons = root.querySelectorAll('[data-tier]');
      const tierPriceLabels = root.querySelectorAll('.protein-bundle__tier-price');
      const tierLineActive = root.querySelector('[data-tier-line-active]');
      const flavorRows = root.querySelectorAll('.protein-bundle__flavor');
      const addButton = root.querySelector('[data-bundle-add]');
      const totalPriceEl = root.querySelector('[data-total-price]');
      const comparePriceEl = root.querySelector('[data-compare-price]');
      const errorEl = root.querySelector('[data-bundle-error]');
      const ctaLabel = root.querySelector('[data-cta-label]');
      const summaryList = root.querySelector('[data-summary-list]');
      const summaryEmpty = root.querySelector('[data-summary-empty]');
      const savingRow = root.querySelector('[data-saving-row]');
      const portionRow = root.querySelector('[data-portion-row]');
      const nutritionOptions = root.querySelector('[data-nutrition-options]');
      const nutritionContent = root.querySelector('[data-nutrition-content]');
      /* === [NEW] sticky-bar refs (Патч 2b) === */
      const stickyBar = root.querySelector('[data-sticky-bar]');
      const stickyAdd = root.querySelector('[data-sticky-add]');
      const stickyPrice = root.querySelector('[data-sticky-price]');
      /* === [/NEW] === */
      const moneyFormat = root.dataset.moneyFormat;
      root.dataset.nutritionFallback = root.dataset.nutritionFallback || '';
      const servingsPerPack = Number(root.dataset.servingsPerPack || 20);
      const ctaActiveBg = root.dataset.ctaActiveBg || '#16a34a';
      const ctaActiveBorder = root.dataset.ctaActiveBorder || '#16a34a';
      const ctaDisabledBg = root.dataset.ctaDisabledBg || '#f3f4f6';
      const ctaDisabledBorder = root.dataset.ctaDisabledBorder || '#d1d5db';

      let mainPrice = parseMoneyToCents(root.dataset.mainPrice);
      const flavorBasePrice =
        Array.from(flavorRows)
          .map((row) => Number(row.dataset.flavorPrice || 0))
          .find((price) => price > 0) || 0;
      if (mainPrice <= 0 && flavorBasePrice > 0) {
        mainPrice = flavorBasePrice;
      }

      const tierDiscounts = {
        1: parsePercent(root.dataset.tier1Discount),
        2: parsePercent(root.dataset.tier2Discount),
        3: parsePercent(root.dataset.tier3Discount),
        4: parsePercent(root.dataset.tier4Discount)
      };
      const buildTierPrice = (tier) => {
        const discount = tierDiscounts[tier] || 0;
        const price = Math.round(mainPrice * (100 - discount) / 100);
        return Math.max(0, price);
      };
      const tierPrices = {
        1: buildTierPrice(1),
        2: buildTierPrice(2),
        3: buildTierPrice(3),
        4: buildTierPrice(4)
      };
      const comparePrice = mainPrice;

      tierButtons.forEach((btn, index) => {
        const tier = Number(btn.dataset.tier);
        const label = tierPriceLabels[index];
        if (!label) return;
        const resolvedTierPrice = tierPrices[tier] || 0;
        btn.dataset.tierPrice = String(resolvedTierPrice);
        label.textContent = `${formatMoney(resolvedTierPrice, moneyFormat)}/уп`;
      });

      const getTier = (qty) => {
        if (qty <= 0) return 0;
        if (qty >= 4) return 4;
        if (qty >= 3) return 3;
        if (qty >= 2) return 2;
        return 1;
      };

      const getCount = (row) => Number(row.querySelector('[data-count]').textContent || 0);
      const setCount = (row, next) => {
        row.querySelector('[data-count]').textContent = String(Math.max(0, next));
      };
      const syncRowUi = (row) => {
        const count = getCount(row);
        const quickAdd = row.querySelector('.protein-bundle__quick-add');
        const stepper = row.querySelector('[data-stepper]');
        const hasQty = count > 0;
        quickAdd.style.display = hasQty ? 'none' : 'inline-flex';
        stepper.style.display = hasQty ? 'inline-flex' : 'none';
        row.classList.toggle('is-active', hasQty);
      };

      const renderNutritionOptions = () => {
        if (!nutritionOptions || !nutritionContent) return;
      root.dataset.nutritionFallback = root.dataset.nutritionFallback || '';
        const items = Array.from(flavorRows)
          .map((row) => {
            const title = row.dataset.flavorTitle || '';
            if (!title) return '';
            const iconUrl = row.dataset.nutritionIconUrl || '';
            const icon = iconUrl
              ? `<img class="protein-bundle__nutrition-option-icon" src="${iconUrl}" alt="" width="45" height="45" loading="lazy">`
              : '';
            return `<button type="button" class="protein-bundle__nutrition-option" data-nutrition-title="${title.replace(/"/g, '&quot;')}">${icon}<span>${title}</span></button>`;
          })
          .join('');
        nutritionOptions.innerHTML = items;
        const first = nutritionOptions.querySelector('[data-nutrition-title]');
        if (first) first.click();
      };

      const update = () => {
        let totalQty = 0;
        let totalServings = 0;
        const selectedRows = [];
        flavorRows.forEach((row) => {
          const qty = getCount(row);
          totalQty += qty;
          totalServings += qty * Number(row.dataset.flavorServings || servingsPerPack);
          syncRowUi(row);
          if (qty > 0) selectedRows.push({ title: row.dataset.flavorTitle || '', qty });
        });

        const tier = getTier(totalQty);

        let currentTierButton = null;
        tierButtons.forEach((btn) => {
          const btnTier = Number(btn.dataset.tier);
          const isReached = tier > 0 && btnTier <= tier;
          const isCurrent = btnTier === tier;
          btn.classList.toggle('is-active', isReached);
          btn.classList.toggle('is-current', isCurrent);
          if (isCurrent) currentTierButton = btn;
        });
        if (tierLineActive && currentTierButton) {
          const line = tierLineActive.parentElement;
          const lineRect = line.getBoundingClientRect();
          const dot = currentTierButton.querySelector('.protein-bundle__tier-dot');
          const maxTier = tierButtons.length;
          if (tier >= maxTier) {
            tierLineActive.style.width = `${lineRect.width}px`;
          } else if (dot) {
            const dotRect = dot.getBoundingClientRect();
            const dotCenter = dotRect.left + dotRect.width / 2;
            const progressPx = Math.max(0, Math.min(lineRect.width, dotCenter - lineRect.left));
            tierLineActive.style.width = `${progressPx}px`;
          }
        } else if (tierLineActive) {
          tierLineActive.style.width = '0px';
        }

        let unitPrice = 0;
        if (currentTierButton) {
          unitPrice = Number(currentTierButton.dataset.tierPrice || 0);
        }
        if (unitPrice <= 0 && tierPrices[1] > 0) unitPrice = tierPrices[1];

        const totalPrice = unitPrice * totalQty;

        /* [scenario-C] per-card спецціна vs звичайна (compare_at) + бейдж −% */
        const dispTier = getTier(totalQty) || 1;
        const dispUnit = tierPrices[dispTier] || tierPrices[1] || unitPrice;
        let totalCompareRegular = 0;
        flavorRows.forEach((row) => {
          const qty = getCount(row);
          const cmp = Number(row.dataset.flavorCompare || 0);
          /* [2026-07-10] економія: картки без реального compare_at (кава) — базою беремо mainPrice (999), а не вигаданий якір */
          const rowRegular = cmp > 0 ? cmp : mainPrice;
          totalCompareRegular += rowRegular * qty;
          const box = row.querySelector('[data-flavor-price-box]');
          if (!box) return;
          /* Ціновий бейдж лише де є справжня стара ціна (матча). Кава — без бейджа, як звичайний товар. */
          if (cmp > dispUnit) {
            const nowEl = box.querySelector('[data-flavor-now]');
            const cmpEl = box.querySelector('[data-flavor-compare]');
            const offEl = box.querySelector('[data-flavor-off]');
            if (nowEl) nowEl.textContent = formatMoney(dispUnit, moneyFormat);
            if (cmpEl) { cmpEl.textContent = formatMoney(cmp, moneyFormat); cmpEl.hidden = false; }
            if (offEl) { offEl.textContent = '-' + Math.round((cmp - dispUnit) / cmp * 100) + '%'; offEl.hidden = false; }
            box.hidden = false;
          } else {
            box.hidden = true;
          }
        });

        const totalCompare = totalCompareRegular > 0 ? totalCompareRegular : (comparePrice > 0 ? comparePrice * totalQty : 0);
        const totalSaving = Math.max(0, totalCompare - totalPrice);

        const displayTotalPrice = totalQty > 0 ? totalPrice : tierPrices[1];
        totalPriceEl.textContent = formatMoney(displayTotalPrice, moneyFormat);

        if (totalQty > 0 && totalCompare > totalPrice) {
          comparePriceEl.textContent = formatMoney(totalCompare, moneyFormat);
          comparePriceEl.hidden = false;
        } else {
          comparePriceEl.hidden = true;
        }

        const enabled = totalQty > 0;
        addButton.disabled = !enabled;
        addButton.style.background = enabled ? ctaActiveBg : ctaDisabledBg;
        addButton.style.border = `1px solid ${enabled ? ctaActiveBorder : ctaDisabledBorder}`;
        ctaLabel.textContent = enabled ? (root.dataset.ctaActiveLabel || 'ДОДАТИ ДО КОШИКА') : (root.dataset.ctaDisabledLabel || 'Оберіть щонайменше 1 упаковку');

        if (summaryList && summaryEmpty) {
          if (selectedRows.length) {
            summaryList.hidden = false;
            summaryEmpty.hidden = true;
            summaryList.innerHTML = selectedRows
              .map((row) => `<div class="protein-bundle__summary-row"><span>${row.title} × ${row.qty}</span><strong>${formatMoney(row.qty * unitPrice, moneyFormat)}</strong></div>`)
              .join('');
          } else {
            summaryList.hidden = true;
            summaryEmpty.hidden = false;
            summaryList.innerHTML = '';
          }
        }

        if (savingRow) {
          if (totalSaving > 0) {
            const savingPct = totalCompare > 0 ? Math.round(totalSaving / totalCompare * 100) : 0;
            savingRow.textContent = `${root.dataset.savingPrefix || 'Економія:'} ${formatMoney(totalSaving, moneyFormat)}${savingPct > 0 ? ` (−${savingPct}%)` : ''}`;
          } else {
            savingRow.textContent = '';
          }
        }
        if (portionRow) {
          if (totalServings > 0) {
            const portionValue = totalPrice / totalServings;
            const cleanSuffix = (root.dataset.portionSuffix || 'порція').replace(/грн|₴/gi, '').replace(/^\/+|\/+$/g, '').trim() || 'порція';
            portionRow.textContent = `${root.dataset.portionPrefix || '~'} ${formatMoney(Math.round(portionValue))}/${cleanSuffix}`;
          } else {
            portionRow.textContent = '';
          }
        }

        /* === [NEW] mirror state into sticky bar (Патч 2c) === */
        if (stickyBar) {
          stickyBar.hidden = false;
          if (stickyPrice) stickyPrice.textContent = formatMoney(displayTotalPrice, moneyFormat);
          if (stickyAdd) {
            stickyAdd.disabled = !enabled;
            stickyAdd.style.background = enabled ? ctaActiveBg : ctaDisabledBg;
            stickyAdd.style.border = `1px solid ${enabled ? ctaActiveBorder : ctaDisabledBorder}`;
            stickyAdd.textContent = ctaLabel.textContent;
          }
        }
        /* === [/NEW] === */

        errorEl.hidden = true;
      };

      /* === [PATCH] Вся картка смаку клікабельна (fix dead-кліків ~10% тапів).
         Тап по тілу картки = додати першу упаковку; кнопки −/+/quick-add працюють як і раніше. === */
      flavorRows.forEach((row) => {
        row.addEventListener('click', (event) => {
          const button = event.target.closest('button[data-action]');

          if (button) {
            const action = button.dataset.action;
            const current = getCount(row);
            if (action === 'minus') setCount(row, current - 1);
            if (action === 'plus') setCount(row, current + 1);
            if (action === 'quick-add') setCount(row, current + 1);
            update();
            return;
          }

          // [NEW] тап по будь-якому місцю картки (не по кнопці) = додати першу упаковку
          if (getCount(row) === 0) {
            setCount(row, 1);
            update();
          }
        });
      });
      /* === [/PATCH] === */

      addButton.addEventListener('click', async () => {
        const items = [];
        flavorRows.forEach((row) => {
          const quantity = getCount(row);
          const variantId = Number(row.dataset.variantId || 0);
          if (variantId > 0 && quantity > 0) {
            items.push({
              id: variantId,
              quantity,
              properties: {
                Bundle: 'Protein Coffee'
              }
            });
          }
        });

        if (!items.length) {
          errorEl.textContent = 'Select at least 1 bag.';
          errorEl.hidden = false;
          return;
        }

        addButton.setAttribute('aria-busy', 'true');
        addButton.disabled = true;

        try {
          const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          const payload = { items };
          if (cart && typeof cart.getSectionsToRender === 'function') {
            payload.sections = cart.getSectionsToRender().map((section) => section.id);
            payload.sections_url = window.location.pathname;
            if (typeof cart.setActiveElement === 'function') {
              cart.setActiveElement(document.activeElement);
            }
          }

          /* [2026-07-09 · Claude · custom-cart] було: routes.cart_add_url без .js — HTML замість JSON */
          const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
          });

          if (!response.ok) {
            throw new Error('Add to cart failed');
          }

          const responseData = await response.json();
          if (cart && typeof cart.renderContents === 'function') {
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'protein-bundle-builder',
                cartData: responseData
              });
            }
            cart.renderContents(responseData);
          } else {
            window.location.href = window.Shopify.routes.root + 'cart';
          }
        } catch (error) {
          errorEl.textContent = 'Could not add items to cart. Please try again.';
          errorEl.hidden = false;
          update();
        } finally {
          addButton.removeAttribute('aria-busy');
        }
      });

      /* === [NEW] sticky-bar click = основной add-to-cart (Патч 2d) === */
      if (stickyAdd) stickyAdd.addEventListener('click', () => addButton.click());
      /* === [/NEW] === */

      if (nutritionOptions && nutritionContent) {
        nutritionOptions.addEventListener('click', (event) => {
          const target = event.target.closest('[data-nutrition-title]');
          if (!target) return;
          nutritionOptions.querySelectorAll('[data-nutrition-title]').forEach((item) => item.classList.remove('is-active'));
          target.classList.add('is-active');
          const title = target.dataset.nutritionTitle;
          const found = Array.from(flavorRows).find((row) => row.dataset.flavorTitle === title);
          const tpl = found ? found.querySelector('template[data-nutrition-template]') : null;
          if (tpl && tpl.innerHTML.trim().length) {
            nutritionContent.innerHTML = tpl.innerHTML;
          } else {
            nutritionContent.textContent = root.dataset.nutritionFallback || '';
          }
        });
      }

      renderNutritionOptions();
      /* === [NEW] дефолт: 1 уп. первого смаку → CTA активна сразу (Патч 1).
         Не нужен дефолт? — удали следующую строку. === */
      if (flavorRows.length) setCount(flavorRows[0], 1);
      update();
    });
  })();


    /* ==========================
     DELIVERY ETA PILL
     ========================== */
  (function () {
    var etaNodes = document.querySelectorAll('[data-delivery-eta]');
    if (!etaNodes.length) return;

    var weekdayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    etaNodes.forEach(function (node) {
      var daysAttr = node.getAttribute('data-days');
      var days = parseInt(daysAttr, 10);
      if (isNaN(days)) days = 0;

      var today = new Date();
      // Normalize to midnight to avoid timezone issues
      var target = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate() + days
      );

      var weekday = weekdayNames[target.getDay()];
      var day = String(target.getDate()).padStart(2, '0');
      var month = monthNames[target.getMonth()];

      // Example: Wednesday, 10 Dec
      node.textContent = weekday + ', ' + day + ' ' + month;
    });
  })();

  /* ==========================
     [NEW] МОБАЙЛ: заголовок + рейтинг (app-віджет) НАД фото
     Переносимо РЕАЛЬНІ ноди (без дублювання app-зірок). Десктоп — без змін.
     ========================== */
  (function () {
    var mq = window.matchMedia('(max-width: 749px)');
    document.querySelectorAll('[id^="MainProduct-"]').forEach(function (sec) {
      var media = sec.querySelector('.product__media-wrapper');
      var info = sec.querySelector('.product__info-wrapper');
      var head = sec.querySelector('[data-mobile-head]');
      if (!media || !info || !head) return;
      var title = info.querySelector(':scope > .protein-bundle__title');
      var meta = info.querySelector(':scope > .protein-bundle__meta');
      if (!title || !meta) return;

      function place() {
        if (mq.matches) {
          // мобайл: заголовок + рейтинг над фото
          head.appendChild(title);
          head.appendChild(meta);
          head.style.display = 'block';
        } else {
          // десктоп: повертаємо на місце (заголовок, потім meta) у верх панелі
          info.insertBefore(meta, info.firstChild);
          info.insertBefore(title, meta);
          head.style.display = 'none';
        }
      }
      place();
      if (mq.addEventListener) mq.addEventListener('change', place);
      else if (mq.addListener) mq.addListener(place);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
